module.exports = __webpack_public_path__ + "media/clock-ticking.f9d12bb0.mp3";